/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let Shape3DPlane = class Shape3DPlane extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createPlane(1000000, shape.normal.x, shape.normal.y, shape.normal.z, shape.distance);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        return undefined;
    }
};
Shape3DPlane = tslib_1.__decorate([
    Shape('Shape3D.Plane'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DPlane);
export { Shape3DPlane };
//# sourceMappingURL=Shape3DPlane.js.map